import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import {
  Border,
  Button,
  Text,
  ButtonModal,
} from 'spindl-shared-components';
import ModalRowList from '../../molecules/ModalRowList';

import styles from './RowExpandedModal.module.scss';
import usePresenter from './RowExpandedModal.presenter';
import getProps from './RowExpandedModal.props';
import { RowExpandedModalCombinedProps } from './types';


// MANUAL OVERRIDE - converted to observer Component
const RowExpandedModal: React.FC<RowExpandedModalCombinedProps> = observer((props) => {
  const {
    className,
    classes,
    tableName,
    closeButton,
    rowNumber,
    button,
    border,
    modalRowList,
    deleteModal, // MANUAL OVERRIDE
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.rowExpandedModal;

  return (
    <div className={cx(currentStyle, className)}>
      <ButtonModal className={cx(styles.deleteModal, classes?.deleteModal)} // MANUAL OVERRIDE
        {...internalProps.deleteModal}
        {...deleteModal}/>
      <div className={cx(styles.topContent, classes?.topContent)}>
        <div className={cx(styles.content, classes?.content)}>
          <div className={cx(styles.label, classes?.label)}>
            <Text
              className={cx(styles.tableName, classes?.tableName)}
              {...internalProps.tableName}
              {...tableName}
            />
            <Button
              className={cx(styles.closeButton, classes?.closeButton)}
              {...internalProps.closeButton}
              {...closeButton}
            />
          </div>
          <div className={cx(styles.rowInfo, classes?.rowInfo)}>
            <Text
              className={cx(styles.rowNumber, classes?.rowNumber)}
              {...internalProps.rowNumber}
              {...rowNumber}
            />
            <Button
              className={cx(styles.button, classes?.button)}
              {...internalProps.button}
              {...button}
            />
          </div>
        </div>
        <Border
          className={cx(styles.border, classes?.border)}
          {...internalProps.border}
          {...border}
        />
      </div>
      <div className={cx(styles.bottomContent, classes?.bottomContent)}>
        <ModalRowList
          className={cx(styles.modalRowList, classes?.modalRowList)}
          {...internalProps.modalRowList}
          {...modalRowList}
        />
      </div>
    </div>
  );
}); // MANUAL OVERRIDE

export default RowExpandedModal;
